import { CircleAlert } from 'lucide-react';

import { cn } from 'src/lib/utils';

export type AlertVariant = 'alert' | 'warning';

const alertStyles: Record<
  AlertVariant,
  {
    background: string;
    border: string;
  }
> = {
  alert: {
    background: 'bg-rose-500',
    border: 'border-rose-400',
  },
  warning: {
    background: 'bg-orange-400',
    border: 'border-orange-300',
  },
};

type Props = {
  variant: AlertVariant;
  className?: string;
  iconClassName?: string;
  strokeWidth?: number;
};

const EscrowAlertBadge = ({ variant, className, iconClassName, strokeWidth = 2 }: Props) => {
  const { background, border } = alertStyles[variant];

  return (
    <div className={cn('size-4 rounded-full border flex items-center justify-center', background, border, className)}>
      <CircleAlert className={cn('size-3.5 text-white', iconClassName)} strokeWidth={strokeWidth} />
    </div>
  );
};

export default EscrowAlertBadge;
